webpackJsonp([1],{

/***/ 101:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 108:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'servers',
  data: function data() {
    return {
      notSmallScreen: true,
      showSnackbar: false,
      position: 'center',
      duration: 4000,
      snackMessage: 'Test Here',
      uptime: '',
      cards: [{
        title: 'Pre-fab homes',
        src: '/doc-images/cards/house.jpg',
        flex: 6
      }, {
        title: 'Favorite road trips',
        src: '/doc-images/cards/road.jpg',
        flex: 6
      }, {
        title: 'Best airlines',
        src: '/doc-images/cards/plane.jpg',
        flex: 6
      }]
      //  socket : io('ithinkijustpoopedmypantspanel.keinett.us')
    };
  },
  methods: {
    handleResize: function handleResize(event) {
      if (document.documentElement.clientWidth > 600) {
        this.notSmallScreen = true;
      } else {
        this.notSmallScreen = false;
      }
    },
    getTotalPlayers: function getTotalPlayers() {
      var _this = this;

      this.$http.get('/panel/totalplayers').then(function (response) {}).catch(function (e) {
        _this.showSnackbar = true;
        _this.snackMessage = 'Error getting totalPlayers!';
      });
    },
    logout: function logout() {
      localStorage.removeItem('jwtToken');
      this.$router.push({
        name: 'AppLogin'
      });
    },
    navipage: function navipage(page) {
      this.$router.push({
        name: page
      });
    }
  },
  beforeMount: function beforeMount() {},

  created: function created() {},
  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    console.log('MOUNTED');

    // this.socket.on('SERVERINFO', (response) => {
    //     this.os = response.os;
    //
    //     var seconds = parseInt(this.os.uptime, 10);
    //
    //     var days = Math.floor(seconds / (3600 * 24));
    //     seconds -= days * 3600 * 24;
    //     var hrs = Math.floor(seconds / 3600);
    //     seconds -= hrs * 3600;
    //     var mnts = Math.floor(seconds / 60);
    //     seconds -= mnts * 60;
    //     this.uptime = days + "d " + hrs + "h " + mnts + "m " + seconds + "s";
    // });
    //
    // this.socket.on('PLAYERINFO', (response) => {
    //     this.totalPlayers = response.players.online;
    // });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    noAccess: function noAccess() {
      return !(this.$ability.rules.length > 0);
    }
  }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casl_ability_extra__ = __webpack_require__(69);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      email: '',
      password: '',
      showSnackbar: false,
      duration: 4000
    };
  },

  methods: {
    goToSignin: function goToSignin() {
      this.$router.push({
        name: 'AppSignup'
      });
    },
    login: function login() {
      var _this = this;

      var loginObj = {
        username: this.email,
        password: this.password
      };
      this.$http.post('/auth/login/', loginObj).then(function (response) {

        var decoded = __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken___default.a.decode(response.data.token.split(" ")[1]);
        localStorage.setItem('jwtToken', response.data.token);

        _this.processRules(decoded.rules);

        _this.$router.push({
          name: 'MainPage'
        });
      }).catch(function (e) {
        console.log(e);
        _this.$root.$emit('snackbar', e.response.data.msg);
      });
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      email: '',
      password: '',
      showSnackbar: false,
      duration: 4000
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      var loginObj = {
        username: this.email,
        password: this.password
      };

      this.$http.post('/auth/register/', loginObj).then(function (response) {
        localStorage.setItem('jwtToken', response.data.token);
        _this.$router.push({
          name: 'AppLogin'
        });
      }).catch(function (e) {
        console.log(e.response.data.msg);
        _this.showSnackbar = true;
        _this.snackMessage = e.response.data.msg;
      });
    }
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_HighRiskConfirmDialog__ = __webpack_require__(443);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "JobPage",
  components: {
    HighRiskConfirmDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_HighRiskConfirmDialog__["a" /* default */]
  },
  data: function data() {
    return {
      search: '',
      confirmDialog: false,
      highRiskActionType: '',
      highRiskConfirmMessage: '',
      jobIdToModify: '',
      includeFinalized: false,
      dialog: false,
      beginDate: null,
      endDate: null,
      date1: null,
      date2: null,
      dateFormatted: null,
      menu1: false,
      menu2: false,
      fab: false,
      headers: [{ text: 'Job ID', value: 'jobName' }, { text: 'Job Date', value: 'jobDate' }, { text: 'Status', value: 'jobStatus' }, { text: 'Actions', value: 'actions' }],
      jobs: []
    };
  },

  computed: {
    beginDateFormat: function beginDateFormat() {
      return this.formatDate(this.date1);
    },
    endDateFormat: function endDateFormat() {
      return this.formatDate(this.date2);
    }
  },
  watch: {
    date: function date(val) {
      this.dateFormatted = this.formatDate(this.date);
    }
  },
  methods: {
    openHighRiskDialog: function openHighRiskDialog(jobname, actiontype, confirmstring) {
      this.jobIdToModify = jobname;
      this.highRiskConfirmMessage = confirmstring;
      this.highRiskActionType = actiontype;
      this.confirmDialog = true;
    },
    performHighRiskAction: function performHighRiskAction(value) {
      var _this = this;

      var jobid = value.confirmString;
      if (value.actionType === "deletejob") {
        console.log("Confirmed delete job for " + jobid);
        this.confirmDialog = false;

        this.$http.post('/job/' + jobid + '/delete', { jobid: jobid }, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        }).then(function (response) {
          if (response.data.success) {
            _this.$root.$emit('snackbar', response.data.msg);
          } else {
            _this.$root.$emit('snackbar', response.data.msg);
          }

          _this.loadJobList();
        }).catch(function (e) {
          // console.log(JSON.stringify(e));
          _this.$root.$emit('snackbar', 'Error deleting job ' + id);
        });
      } else if (value.actionType === "resortjob") {
        console.log("Confirmed resort job for " + jobid);

        this.confirmDialog = false;

        this.$http.post('/job/' + jobid + '/resort', { jobid: jobid }, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        }).then(function (response) {
          if (response.data.success) {
            _this.$root.$emit('snackbar', response.data.msg);
          } else {
            _this.$root.$emit('snackbar', response.data.msg);
          }

          _this.loadJobList();
        }).catch(function (e) {
          // console.log(JSON.stringify(e));
          _this.$root.$emit('snackbar', 'Error setting job to resorting photos/listin' + id);
        });
      }
    },
    resortJob: function resortJob(id) {
      console.log("Handle resort " + id);
    },
    loadJobList: function loadJobList() {
      var _this2 = this;

      this.beginDate = this.date1;
      this.endDate = this.date2;
      this.dialog = false;
      this.$http.get('/jobs/yearrange/' + this.beginDate + '/' + this.endDate + '/' + this.includeFinalized, {
        headers: {
          'Authorization': localStorage.getItem('apiKey')
        }
      }).then(function (response) {
        _this2.jobs = [];
        for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.data).length; i++) {

          var job = response.data[i];

          var job_id = String(job.job_id).toUpperCase().split("_")[1];
          var job_date = _this2.dateFormatUTC(job.date);
          var job_status = job.status;
          var job_finalized_date = job.finalized_date;
          var job_formsimported = job.formsimported;
          var job_notes = job.notes;

          _this2.jobs.push({
            rawId: job.job_id,
            jobName: job_id,
            jobDate: job_date,
            jobStatus: job_status,
            jobFormStatus: job_formsimported,
            jobFinalizedDate: job_finalized_date,
            jobNotes: job_notes
          });
        }
        console.log(_this2.users);
      }).catch(function (e) {
        _this2.$root.$emit('snackbar', 'Error retrieving user list!');
        console.log(e);
      });
    },
    resetDateRange: function resetDateRange() {
      this.date1 = this.beginDate;
      this.date2 = this.endDate;
      this.dialog = false;
    },
    dateFormatUTC: function dateFormatUTC(rawDate) {
      var date_Raw = new Date(Date.parse(rawDate));
      var formattedDate = date_Raw.getUTCMonth() + 1 + "-" + date_Raw.getUTCDate() + "-" + date_Raw.getUTCFullYear();
      return formattedDate;
    },
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return month + '/' + day + '/' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split('/'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          month = _date$split4[0],
          day = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    },
    onScroll: function onScroll() {
      if (typeof window === "undefined") return;
      var top = window.pageYOffset || document.documentElement.offsetTop || 0;
      this.fab = top > 100;
    },
    toTop: function toTop() {
      this.$vuetify.goTo(0);
    }
  },
  mounted: function mounted() {
    // get fiscal year
    var currentDate = new Date();
    // month is before july
    if (currentDate.getMonth() <= 5) {
      this.date1 = String(currentDate.getFullYear() - 1) + '-07-01';
      this.date2 = String(currentDate.getFullYear()) + '-07-01';
    } else {
      this.date1 = String(currentDate.getFullYear()) + '-07-01';
      this.date2 = String(currentDate.getFullYear() + 1) + '-07-01';
    }
    // load job list
    this.loadJobList();
  }
});

/***/ }),

/***/ 144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_generate_password__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_generate_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_generate_password__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CreateUserDialog",
  props: {
    confirmString: "",
    actionType: "",
    confirmMessage: "",
    visible: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      formHasErrors: false,
      typedString: '',
      username: '',
      errorMessages: [],
      permissions: []
    };
  },

  computed: {
    matches: function matches() {
      return this.confirmString !== this.typedString;
    },

    show: {
      get: function get() {
        this.typedString = "";
        return this.visible;
      },
      set: function set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    },
    confirmAction: function confirmAction() {
      if (this.confirmString === this.typedString) {
        this.$emit('confirmed', { actionType: this.actionType, confirmString: this.confirmString });
      }
    }
  }
});

/***/ }),

/***/ 145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_instant_pdf_viewer__ = __webpack_require__(450);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var toLower = function toLower(text) {
  return text.toString().toLowerCase();
};

var searchByName = function searchByName(items, term) {
  if (term) {
    return items.filter(function (item) {
      return toLower(item.filename).includes(toLower(term));
    });
  }
  return items;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableSearch',
  data: function data() {
    return {
      openedfilename: null,
      dialog: false,
      dialogloading: false,
      valueDeterminate: 0,
      pdfurl: 'https://bitcoin.org/bitcoin.pdf',
      search: '',
      headers: [{
        text: 'Job PDF Name',
        align: 'left',
        sortable: true,
        value: 'filename'
      }, {
        text: 'Time',
        value: 'ctime'
      }, {
        text: 'Open',
        value: ''
      }],
      data: [],
      showSnackbar: false,
      duration: 4000,
      snackMessage: '',
      resultsPerPage: 10000,
      currentPage: 0,
      totalPages: null
    };
  },
  methods: {
    newUser: function newUser() {
      window.alert('Noop');
    },
    searchOnTable: function searchOnTable() {
      this.searched = searchByName(this.users, this.search);
    },
    updateProgressBarValue: function updateProgressBarValue(value) {
      this.valueDeterminate = value;
    },
    openPDF: function openPDF(name) {
      var _this = this;

      this.openedfilename = name;
      this.dialogloading = true;
      this.valueDeterminate = 0;

      this.$http.get('/panel/review/' + name, {
        responseType: 'arraybuffer',
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        },
        onDownloadProgress: function (progressEvent) {
          var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
          this.updateProgressBarValue(percentCompleted);
        }.bind(this)
      }).then(function (response) {
        // Create a Blob from the PDF Stream

        var file = new Blob([response.data], {
          type: 'application/pdf'
        });
        // Build a URL from the file

        var fileURL = window.URL.createObjectURL(file);
        // Open the URL on new Window
        _this.pdfurl = fileURL;
        _this.dialogloading = false;
        _this.dialog = true;
      }).catch(function (e) {
        console.log(e);
        _this.showSnackbar = true;
        _this.snackMessage = 'Error getting pdf list!';
        _this.dialogloading = false;
      });
    },
    loadReviewList: function loadReviewList() {
      var _this2 = this;

      this.$http.get('/panel/review/' + this.resultsPerPage + '/' + this.currentPage, {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {
        _this2.data = response.data.data;
        _this2.searched = response.data.data;
        _this2.totalPages = response.data.tpage;
        _this2.currentPage = response.data.cpage;
      }).catch(function (e) {
        _this2.showSnackbar = true;
        _this2.snackMessage = 'Error getting pdf list!';
      });
    }
  },
  created: function created() {
    this.searched = this.users;
  },
  mounted: function mounted() {
    console.log('REVIEW MOUNTED');
    this.loadReviewList();
  },

  components: {
    'vue-pdf-viewer': __WEBPACK_IMPORTED_MODULE_0_vue_instant_pdf_viewer__["a" /* default */]
  }

});

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(453);

exports.default = {
  mounted: function mounted() {
    if ((0, _lodash.isUndefined)(window.PDFObject)) {
      console.error('VuePDFViewer Error: PDFObject not found. ' + 'Get it here: https://pdfobject.com, please include js file.');
      return;
    }
    if ((0, _lodash.isUndefined)(this.url)) {
      console.error('VuePDFViewer Error: no file url provided');
      return;
    }
    PDFObject.embed(this.url, this.$el);
  },
  props: ['height', 'url'],
  data: function data() {
    var vm = this;
    var h = '400px';
    if (!vm.height) {
      console.warn('Please specify viewer height, e.g. height="500px"');
    } else {
      h = vm.height;
    }
    return {
      styleObject: {
        height: h
      }
    };
  },
  watch: {
    url: function url(val) {
      var vm = this;
      PDFObject.embed(val, vm.$el);
    }
  }
};

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      active: null,
      messages: [],
      tabindex: 0,
      smallscreen: false,
      headers: [{ text: 'User', align: 'left', sortable: false, value: 'email' }, { text: "Activity", align: 'left', sortable: false }]
    };
  },

  methods: {
    handleMessage: function handleMessage(msg) {
      this.messages.push(JSON.parse(msg));
    },
    handleResize: function handleResize(event) {
      if (document.documentElement.clientWidth > 600) {
        this.smallscreen = false;
      } else {
        this.smallscreen = true;
      }
    },

    boxColor: function boxColor(eventlevel) {
      if (eventlevel > 50) {
        return "accent";
      } else {
        return "info";
      }
    }
  },
  created: function created() {
    this.$store.dispatch('GET_LATEST_LOGS');
    //Socket.$on("message", this.handleMessage)
  },

  computed: {
    logs: function logs() {
      return this.$store.getters.logs;
    },
    sessions: function sessions() {
      return this.$store.getters.sessions;
    }
  },
  beforeDestroy: function beforeDestroy() {
    //Socket.$off("message", this.handleMessage)
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.handleResize);
    console.log("MOUNTED");
  }
});

/***/ }),

/***/ 148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_graphs_BacklogGraph__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Dashboard',
  components: { BacklogGraph: __WEBPACK_IMPORTED_MODULE_4__components_graphs_BacklogGraph__["a" /* default */] },
  data: function data() {
    return {
      activeTab: null,

      search: '',
      headers1: [{ text: 'Screener', value: 'screener_name' }, { text: 'Job ID', value: 'job_id' }, { text: 'Status', value: 'status_displayname' }, { text: 'Unit', value: 'camid' }, { text: 'Type', value: 'isdigital' }, { text: 'Screened', value: 'screened' }, { text: 'X Count', value: 'xcount' }, { text: 'Analyzed Count', value: '' }, { text: '% X\'s', value: '' }, { text: 'Dilate', value: 'dilate' }, { text: 'Lookoff', value: 'lookoff' }, { text: 'Force', value: 'force_eye' }, { text: 'Focus', value: 'focus' }],
      analyzedData: [],

      totals: [],

      status: 'Done',
      statusRule: 'Get only this status',
      statuses: [],

      selectedJobInfo: null,

      loading: false,
      expand: false,
      dialog: false,
      formValid: true,
      startDate: '',
      endDate: '',
      finalDate: null, // date time
      rules: {
        startDate: [function (v) {
          return !!v || 'Start date is required.';
        }],
        endDate: [function (v) {
          return !!v || 'End date is required.';
        }]
      },
      menu: {
        startdate: false,
        enddate: false
      }
    };
  },
  watch: {
    activeTab: function activeTab(newVal) {
      if (newVal === 1) this.$refs.graph.loadGraph();
    }
  },
  methods: {
    updateSearch: function updateSearch() {
      this.dialog = false;
      this.getData();
    },
    expandRow: function expandRow(props) {
      var _this = this;

      // only open actual job ids
      if (!isNaN(props.item.job_id)) return;
      props.expanded = !props.expanded;
      // don't grab data on expand false
      if (!props.expanded) return;
      // reset data
      this.selectedJobInfo = null;
      // get job info
      // https://vrc.api.maxis.io/v1/job/job_id
      this.$http.get('job/' + props.item.job_id, {
        headers: { 'Authorization': localStorage.getItem('apiKey') }
      }).then(function (response) {
        _this.selectedJobInfo = response.data[0];
      }).catch(function (error) {});
    },
    formatDate: function formatDate(date) {
      date = new Date(date);
      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
    },
    populateStatuses: function populateStatuses() {
      var _this2 = this;

      this.$http.get('/jobs/status_priority', {
        headers: { 'Authorization': localStorage.getItem('apiKey') }
      }).then(function (response) {
        _this2.statuses = response.data.map(function (obj) {
          return obj.displayname;
        });
      }).catch(function (error) {});
    },
    generateTablePDF: function generateTablePDF() {
      var start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.startDate);
      var end = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.endDate);

      var pdfTableFontSize = 8;

      // create table header
      var tableHeader = ['Screener', 'Loc\'s', '# Scrnd', '# X\'s', '# Anal\'d', '% X\'s', 'Dilate', 'Lookoff', 'Force', 'Focus', 'Total'];
      tableHeader = tableHeader.map(function (e) {
        return { text: e, fontSize: pdfTableFontSize };
      });

      // create table data
      var table = this.totals.map(function (e) {
        return [{ text: e.screener_name.replace(' (TOTAL)', ''), fontSize: pdfTableFontSize }, { text: e.job_id, fontSize: pdfTableFontSize }, { text: e.screened, fontSize: pdfTableFontSize }, { text: e.xcount, fontSize: pdfTableFontSize }, { text: e.screened - e.xcount, fontSize: pdfTableFontSize }, { text: (100 * (e.xcount / e.screened)).toFixed(2) + '%', fontSize: pdfTableFontSize }, { text: e.dilate, fontSize: pdfTableFontSize }, { text: e.lookoff, fontSize: pdfTableFontSize }, { text: e.force_eye, fontSize: pdfTableFontSize }, { text: e.focus, fontSize: pdfTableFontSize }, { text: e.dilate + e.lookoff + e.force_eye + e.focus, fontSize: pdfTableFontSize }];
      });
      // sort table by x count
      table = table.sort(function (a, b) {
        return a[3].text - b[3].text;
      });

      // add table header to table
      table.unshift(new Array(11).fill({ text: ' ', fontSize: pdfTableFontSize }));
      table.unshift(tableHeader);

      // pdf options
      var dd = {
        pageSize: 'A5',
        pageOrientation: 'landscape',
        content: [{
          columns: [{ width: '*', text: '' }, {
            width: 'auto',
            table: {
              body: [['Summary Ranked']]
            }
          }, { width: '*', text: '' }]
        }, {
          text: [{
            text: 'Jobs completed ' + start.format('MM/DD') + ' - ' + end.format('MM/DD/YY'),
            fontSize: 9,
            color: 'blue'
          }]
        }, {
          layout: 'noBorders',
          table: {
            style: 'table',
            body: table
          }
        }],
        styles: {
          table: {
            fontSize: 6
          }
        }
        // create pdf
      };__WEBPACK_IMPORTED_MODULE_5_pdfmake___default.a.createPdf(dd).download('jobcompleted_' + start.format('MM-DD-YY') + '_' + end.format('MM-DD-YY'));
    },
    getData: function getData() {
      var _this3 = this;

      this.$http.get('/jobs/xsummary/' + this.startDate + '/' + this.endDate + '?status=' + encodeURI(this.status) + '&greaterthan=' + (this.statusRule !== 'Get only this status'), {
        headers: { 'Authorization': localStorage.getItem('apiKey') }
      }).then(function (response) {
        _this3.analyzedData = response.data;

        // get totals
        var totals = {};
        _this3.analyzedData.forEach(function (each) {
          if (!totals[each.screener_name]) {
            totals[each.screener_name] = {
              locations: 1,
              xcount: each.xcount,
              screened: each.screened,
              dilate: each.dilate,
              lookoff: each.lookoff,
              force_eye: each.force_eye,
              focus: each.focus
            };
          } else {
            totals[each.screener_name].locations += 1;
            totals[each.screener_name].xcount += each.xcount;
            totals[each.screener_name].screened += each.screened;
            totals[each.screener_name].dilate += each.dilate;
            totals[each.screener_name].lookoff += each.lookoff;
            totals[each.screener_name].force_eye += each.force_eye;
            totals[each.screener_name].focus += each.focus;
          }
        });

        // create a list of totals
        _this3.totals = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(totals).map(function (key) {
          return {
            screener_name: key + ' (TOTAL)',
            job_id: totals[key].locations,
            xcount: totals[key].xcount,
            screened: totals[key].screened,
            dilate: totals[key].dilate,
            lookoff: totals[key].lookoff,
            force_eye: totals[key].force_eye,
            focus: totals[key].focus
          };
        });

        // merge totals with main list
        _this3.analyzedData = _this3.analyzedData.concat(_this3.totals);
      }).catch(function (error) {});
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var currDate, start, end;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this4.loading = true;

              // set date range
              currDate = new Date();
              // if (currDate.getMonth() + 1 < 7) {
              //   this.startDate = `${currDate.getFullYear() - 1}-7-1`
              //   this.endDate = `${currDate.getFullYear()}-7-1`
              // } else {
              //   this.startDate = `${currDate.getFullYear()}-7-1`
              //   this.endDate = `${currDate.getFullYear() + 1}-7-1`
              // }

              start = new Date();

              // set to Monday of this week

              start.setDate(start.getDate() - (start.getDay() + 6) % 7);
              // set to previous Monday
              start.setDate(start.getDate() - 7);
              // get end date at end of that week
              end = new Date(start.getFullYear(), start.getMonth(), start.getDate() + 6);

              _this4.finalDate = end;

              // get last week
              _this4.startDate = start.getFullYear() + '-' + (start.getMonth() + 1) + '-' + start.getDate();
              _this4.endDate = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate();

              // get data
              _context.next = 11;
              return _this4.populateStatuses();

            case 11:
              _context.next = 13;
              return _this4.getData();

            case 13:
              _this4.loading = false;

            case 14:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake__);
//
//
//
//
//
//




var fonts = __webpack_require__(489);
__WEBPACK_IMPORTED_MODULE_2_pdfmake___default.a.vfs = fonts.pdfMake.vfs;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BacklogGraph',
  components: {
    apexcharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
  },
  data: function data() {
    return {
      series: [],
      chartOptions: {
        chart: {
          background: 'transparent',
          zoom: {
            enabled: false
          }
        },
        theme: {
          mode: this.$store.state.darktheme ? 'light' : 'light'
        },
        tooltip: {
          theme: this.$store.state.darktheme ? 'dark' : 'light'
        },
        colors: ['#0000ff', '#0fde00', '#d1c700', '#ff0000'],
        fill: {
          colors: ['#0000ff', '#0fde00', '#faf148', '#ff0000']
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [5, 7, 5, 5],
          curve: 'straight',
          dashArray: [4, 12, 0, 0]
        },

        title: {
          text: 'Backlog',
          align: 'left'
        },
        markers: {
          size: [0, 0, 0, 5],

          hover: {
            sizeOffset: 6
          }
        },
        xaxis: {
          type: 'datetime'
        },
        grid: {
          borderColor: '#f1f1f1'
        }
      },
      // for pdf table
      dates: [],
      screened: null,
      done: null,
      backlog: null
    };
  },
  props: {
    finalDate: {
      type: Date
    }
  },
  computed: {
    themeMode: function themeMode() {
      return this.$store.state.darktheme ? 'dark' : 'light';
    }
  },
  watch: {
    themeMode: function themeMode(newVal) {
      this.chartOptions.theme.mode = newVal;
      this.chartOptions.tooltip.theme = newVal;
    }
  },
  methods: {
    generateGraphPDF: function generateGraphPDF() {
      var _this = this;

      this.$refs.chart.dataURI().then(function (uri) {
        var today = new Date();
        var dd = {
          pageSize: 'A5',
          pageOrientation: 'landscape',
          content: [{
            text: [{ text: 'Backlog as of ' + (today.getMonth() + 1) + '/' + today.getDate(), fontSize: 16 }]
          }, {
            layout: 'noBorders',
            table: {
              style: 'tableExample',
              body: [_this.dates, _this.screened, _this.done, _this.backlog]
            }
          }, {
            image: 'graph',
            width: 525
          }],
          images: {
            graph: uri
          },
          styles: {
            tableExample: {
              fontSize: 4
            }
          }
        };
        __WEBPACK_IMPORTED_MODULE_2_pdfmake___default.a.createPdf(dd).download('backlog_' + today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate());
      });
    },
    loadGraph: function loadGraph() {
      var _this2 = this;

      this.$http.get('/statistics/backlog', {
        headers: { 'Authorization': localStorage.getItem('apiKey') }
      }).then(function (result) {
        var weeks = result.data;
        console.log(weeks);

        var screened = [];
        var done = [];
        var backlog = [];
        var redline = [];

        var pdfTableFontSize = 5;

        for (var el in weeks) {
          var week = weeks[el];
          var enddate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(week.enddate).toDate();
          _this2.dates.push({ text: __WEBPACK_IMPORTED_MODULE_1_moment___default()(week.enddate).format('MM/DD/YY'), fontSize: pdfTableFontSize });
          screened.push([enddate, week.screened]);
          done.push([enddate, week.done]);
          backlog.push([enddate, week.backlog]);
          redline.push([enddate, week.redline === 0 ? null : week.redline]);
        }

        // for pdf
        _this2.screened = screened;
        _this2.done = done;
        _this2.backlog = backlog;

        _this2.screened = _this2.screened.map(function (e) {
          return { text: e[1], fontSize: pdfTableFontSize };
        });
        _this2.done = _this2.done.map(function (e) {
          return { text: e[1], fontSize: pdfTableFontSize };
        });
        _this2.backlog = _this2.backlog.map(function (e) {
          return { text: e[1], fontSize: pdfTableFontSize };
        });

        _this2.dates.unshift({ text: '', fontSize: pdfTableFontSize });
        _this2.screened.unshift({ text: 'Screened', fontSize: pdfTableFontSize });
        _this2.done.unshift({ text: 'Done', fontSize: pdfTableFontSize });
        _this2.backlog.unshift({ text: 'Backlog', fontSize: pdfTableFontSize });

        // for graph
        _this2.series = [{
          name: "Screened",
          data: screened
        }, {
          name: "Done",
          data: done
        }, {
          name: 'Backlog',
          type: 'area',
          data: backlog
        }, {
          name: 'Redline',
          data: redline
        }];
      });
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dialogs_CreateUserDialog__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_dialogs_ScreenerDialog__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_dialogs_ManageUserDialog__ = __webpack_require__(501);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ManageUsers',
  components: {
    CreateUserDialog: __WEBPACK_IMPORTED_MODULE_0__components_dialogs_CreateUserDialog__["a" /* default */],
    ScreenerDialog: __WEBPACK_IMPORTED_MODULE_1__components_dialogs_ScreenerDialog__["a" /* default */],
    ManageUserDialog: __WEBPACK_IMPORTED_MODULE_2__components_dialogs_ManageUserDialog__["a" /* default */]
  },
  data: function data() {
    return {
      manageUserData: null,
      manageUserDialogOpened: false,
      search: '',
      tab: null,
      items: ['users', 'screeners'],
      headers: [{
        text: 'Real Name',
        align: 'left',
        sortable: true,
        value: 'realname'
      }, {
        text: 'Username',
        align: 'left',
        sortable: true,
        value: 'username'
      }, {
        text: 'Last Login',
        align: 'left',
        sortable: true,
        value: 'lastlogin'
      }, {
        text: 'Role',
        align: 'left',
        sortable: true,
        value: 'role'
      }, {
        text: 'Actions',
        align: 'left',
        sortable: false
      }],
      users: [],
      headersScreeners: [{
        text: 'Crew ID',
        align: 'left',
        sortable: true,
        value: 'crewid'
      }, {
        text: 'Name',
        align: 'left',
        sortable: true,
        value: 'name'
      }, {
        text: 'Location',
        align: 'left',
        sortable: true,
        value: 'loc'
      }, {
        text: 'Actions',
        align: 'left',
        sortable: false
      }],
      screeners: []
    };
  },

  methods: {
    openManageUserDialog: function openManageUserDialog(user) {
      this.manageUserDialogOpened = true;
      this.manageUserData = user;
    },
    loadUserList: function loadUserList() {
      var _this = this;

      this.$http.get('/panel/user/list', {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {
        _this.users = response.data;
      }).catch(function (e) {
        _this.$root.$emit('snackbar', 'Error retrieving user list!');
      });
    },
    loadScreenerList: function loadScreenerList() {
      var _this2 = this;

      this.$http.get('/panel/screener', {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {
        _this2.screeners = response.data;
      }).catch(function (e) {
        _this2.$root.$emit('snackbar', 'Error retrieving screener list!');
      });
    },
    deleteUser: function deleteUser(item) {
      var _this3 = this;

      var index = this.users.indexOf(item);
      if (confirm('Are you sure you want to delete this user? (' + item.local.realname + " / " + item.local.email + ')')) {
        this.$http.post('/panel/user/delete', { id: item._id }, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        }).then(function (response) {
          if (response.data.success) {
            _this3.$root.$emit('snackbar', response.data.msg);
          } else {
            _this3.$root.$emit('snackbar', response.data.msg);
          }
          _this3.loadUserList();
        }).catch(function (e) {
          _this3.$root.$emit('snackbar', e.response.data.msg);
        });
      } else {}
    },
    deleteScreener: function deleteScreener(item) {
      var _this4 = this;

      var index = this.screeners.indexOf(item);
      if (confirm('Are you sure you want to delete this screener? (' + item.name + ')')) {
        this.$http.post('/panel/screener/delete', { id: item._id }, {
          headers: {
            'Authorization': localStorage.getItem('jwtToken')
          }
        }).then(function (response) {
          if (response.data.success) {
            _this4.$root.$emit('snackbar', response.data.msg);
            _this4.loadScreenerList();
          } else {
            _this4.$root.$emit('snackbar', response.data.msg);
          }
          _this4.loadUserList();
        }).catch(function (e) {
          _this4.$root.$emit('snackbar', e.response.data.msg);
        });
      } else {}
    }
  },
  mounted: function mounted() {
    this.loadUserList();
    this.loadScreenerList();
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_generate_password__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_generate_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_generate_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gfycat_style_urls__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_gfycat_style_urls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_gfycat_style_urls__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CreateUserDialog",
  data: function data() {
    return {
      dialog: false,
      formHasErrors: false,
      realname: '',
      username: '',
      errorMessages: [],
      userCreated: false,
      createdUserName: '',
      createdRealName: '',
      createdPassword: ''
    };
  },

  computed: {
    form: function form() {
      return {
        realname: this.realname,
        username: this.username
      };
    }
  },
  methods: {
    editUser: function editUser(name) {
      console.log('EDIT USER ' + name);
    },
    close: function close() {
      this.dialog = false;
      this.userItem = {
        realname: '',
        username: '',
        password: '',
        role: ''
      };
    },
    save: function save() {
      var userToCreate = this.userItem;

      this.close();
    },
    loadUserList: function loadUserList() {
      this.$emit('updateUserList');
    },
    createUser: function createUser() {
      var _this = this;

      this.formHasErrors = false;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (f) {
        if (!_this.form[f]) _this.formHasErrors = true;

        _this.$refs[f].validate(true);
      });

      if (!this.realname || !this.username) {
        this.$root.$emit('snackbar', "Fields cannot be empty!");
        return;
      }
      //var password = generator.generate({length: 8, numbers: true})
      var password = __WEBPACK_IMPORTED_MODULE_2_gfycat_style_urls___default.a.generateCombination(1, "").toLowerCase();

      var userObj = { username: this.username, realname: this.realname, password: password };

      this.$http.post('/auth/register', userObj, {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {
        if (response.data.success) {
          _this.createdUserName = _this.username;
          _this.createdRealName = _this.realname;
          _this.createdPassword = password;

          _this.username = '';
          _this.realname = '';

          _this.userCreated = true;
        } else {
          _this.$root.$emit('snackbar', response.data.msg);
        }
      }).catch(function (e) {
        // console.log(JSON.stringify(e));
        _this.$root.$emit('snackbar', e.response.data.msg);
      });
    },
    resetForm: function resetForm() {
      var _this2 = this;

      this.errorMessages = [];
      this.formHasErrors = false;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (f) {
        _this2.$refs[f].reset();
      });
    }
  },
  mounted: function mounted() {
    this.loadUserList();
  },

  watch: {
    dialog: function dialog(newState, oldState) {
      this.realname = '';
      this.username = '';
      this.createdUserName = '';
      this.createdPassword = '';
      this.createdRealName = '';
      this.loadUserList();
      this.errorMessages = [];
      this.formHasErrors = false;
      this.userCreated = false;
    }
  }
});

/***/ }),

/***/ 280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      errorMessages: [],
      name: null,
      loc: null,
      crewid: null,
      formHasErrors: false
    };
  },

  computed: {
    form: function form() {
      return {
        name: this.name,
        loc: this.loc,
        crewid: this.crewid
      };
    }
  },

  watch: {
    name: function name() {
      this.errorMessages = [];
    }
  },

  methods: {
    resetForm: function resetForm() {
      var _this = this;

      this.errorMessages = [];
      this.formHasErrors = false;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (f) {
        _this.$refs[f].reset();
      });
    },
    submit: function submit() {
      var _this2 = this;

      this.formHasErrors = false;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (f) {
        if (!_this2.form[f]) _this2.formHasErrors = true;

        _this2.$refs[f].validate(true);
      });

      if (this.formHasErrors) {
        return;
      }

      var screenerObject = {
        name: this.name,
        hnotes: '',
        loc: this.loc,
        crewid: this.crewid
      };

      this.$http.post('/panel/screener', screenerObject, {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {
        if (response.data.success) {
          _this2.resetForm();
          _this2.$emit('update');
          _this2.dialog = false;
        } else {
          _this2.$root.$emit('snackbar', response.data.msg);
        }
      }).catch(function (e) {
        // console.log(JSON.stringify(e));
        _this2.$root.$emit('snackbar', e.response.data.msg);
      });
    }
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_generate_password__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_generate_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_generate_password__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CreateUserDialog",
  props: {
    userData: {},
    visible: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      formHasErrors: false,
      realname: '',
      username: '',
      errorMessages: [],
      permissions: []
    };
  },

  computed: {
    form: function form() {
      return {
        realname: this.realname,
        username: this.username
      };
    },

    show: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  },
  methods: {
    editUser: function editUser(name) {
      console.log('EDIT USER ' + name);
    },
    close: function close() {
      this.dialog = false;
      this.userItem = {
        realname: '',
        username: '',
        password: '',
        role: ''
      };
    },
    save: function save() {
      var userToCreate = this.userItem;

      this.close();
    },
    loadUserList: function loadUserList() {
      this.$emit('updateUserList');
    },
    updateUser: function updateUser() {
      var _this = this;

      var userData = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.userData));
      var id = userData._id;
      var userDataRuleset = [];

      console.log(this.permissions);

      this.permissions.forEach(function (permission) {
        if (permission.hasPermission) {
          userDataRuleset.push(permission._id);
        }
      });

      userData.rules = userDataRuleset;

      //Remove unneeded fields before pushing to server
      delete userData._id;
      delete userData.__v;

      userData.local.realname = this.realname;

      var updateObject = {
        id: id,
        updateObject: userData
      };

      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(updateObject));

      this.$http.post('/panel/user/update', updateObject, {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {
        if (response.data.success) {
          _this.$emit('updated');
          _this.show = false;
        } else {
          _this.$root.$emit('snackbar', response.data.msg);
        }
      }).catch(function (e) {
        // console.log(JSON.stringify(e));
        _this.$root.$emit('snackbar', e.response.data.msg);
      });
    },
    createUser: function createUser() {
      var _this2 = this;

      this.formHasErrors = false;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (f) {
        if (!_this2.form[f]) _this2.formHasErrors = true;

        _this2.$refs[f].validate(true);
      });

      if (!this.realname || !this.username) {
        this.$root.$emit('snackbar', "Fields cannot be empty!");
        return;
      }
      var password = __WEBPACK_IMPORTED_MODULE_2_generate_password___default.a.generate({ length: 8, numbers: true });

      var userObj = { username: this.username, realname: this.realname, password: password };

      this.$http.post('/auth/register', userObj, {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {
        if (response.data.success) {
          _this2.createdUserName = _this2.username;
          _this2.createdRealName = _this2.realname;
          _this2.createdPassword = password;

          _this2.username = '';
          _this2.realname = '';

          _this2.userCreated = true;
        } else {
          _this2.$root.$emit('snackbar', response.data.msg);
        }
      }).catch(function (e) {
        // console.log(JSON.stringify(e));
        _this2.$root.$emit('snackbar', e.response.data.msg);
      });
    },
    resetForm: function resetForm() {
      var _this3 = this;

      this.errorMessages = [];
      this.formHasErrors = false;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (f) {
        _this3.$refs[f].reset();
      });
    },
    getPermissionList: function getPermissionList() {
      var _this4 = this;

      this.$http.get('/panel/permissions', {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {

        if (response.data) {
          _this4.permissions = response.data;

          _this4.permissions.forEach(function (permission) {
            var id = permission._id;

            permission.hasPermission = false;

            _this4.userData.rules.forEach(function (rule) {
              var id2 = rule._id;

              if (id == id2) {
                permission.hasPermission = true;
              }
            });
          });

          console.log(_this4.userData.rules);
        } else {
          _this4.$root.$emit('snackbar', response.data.msg);
        }
      }).catch(function (e) {
        // console.log(JSON.stringify(e));
        _this4.$root.$emit('snackbar', e.response.data.msg);
      });
    }
  },
  watch: {
    visible: function visible(newState, oldState) {
      console.log(newState);
      console.log(this.userData);

      if (newState) {
        try {
          this.realname = this.userData.local.realname;
          this.getPermissionList();
        } catch (e) {}
      }
    }
  }
});

/***/ }),

/***/ 282:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Downloads',
  data: function data() {
    return {
      downloadUrls: ["http://vrc.api.maxis.io:8000/static/framesorter.json", "http://vrc.api.maxis.io:8000/static/analyzer.json"],
      downloadObjects: []
    };
  },

  methods: {},
  mounted: function mounted() {
    this.getLatestDownloads();
  }
});

/***/ }),

/***/ 283:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_graphs_IndividualUserActivity__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_graphs_UserActivityApex_vue__ = __webpack_require__(565);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IndividualUserGraph: __WEBPACK_IMPORTED_MODULE_0__components_graphs_IndividualUserActivity__["a" /* default */],
    UserActivityApex: __WEBPACK_IMPORTED_MODULE_1__components_graphs_UserActivityApex_vue__["a" /* default */]
  },
  data: function data() {
    return {
      labels: [],
      dataPoints: [],
      height: 20,
      sampleSeries: [{
        name: 'series-1',
        data: [30, 40, 45, 50, 49, 60, 70, 91]
      }, {
        name: 'series-2',
        data: [23, 43, 54, 12, 44, 52, 32, 11]
      }],
      users: [],
      visualization: []
    };
  },

  methods: {
    increaseHeight: function increaseHeight() {
      this.height += 10;
    },
    getRandomInt: function getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    fillData: function fillData() {
      var chartColors = {
        red: 'rgb(255, 99, 132)',
        orange: 'rgb(255, 159, 64)',
        yellow: 'rgb(255, 205, 86)',
        green: 'rgb(75, 192, 192)',
        blue: 'rgb(54, 162, 235)',
        purple: 'rgb(153, 102, 255)',
        grey: 'rgb(231,233,237)'
      };

      this.dataPoints = {
        labels: this.labels,
        datasets: [{
          label: 'Data One',
          backgroundColor: 'transparent',
          borderColor: chartColors.red,
          lineTension: 0,
          data: this.dataPoints

        }]
      };
    },
    loadUserList: function loadUserList() {
      var _this = this;
      this.$http.get('/panel/user/list', {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {
        console.log("GOT USER LIST");
        _this.users = response.data;
        console.log(_this.users);
      }).catch(function (e) {
        _this.$root.$emit('snackbar', 'Error retrieving user list!');
      });
    },
    buildBubbleJobChart: function buildBubbleJobChart(sample_data) {
      // instantiate d3plus
      this.visualization = d3plus.viz().container("#viz") // container DIV to hold the visualization
      .data(sample_data) // data to use with the visualization
      .type("bubbles") // visualization type
      .id(["date", "job_id"]) // nesting keysx
      .depth(1) // 0-based depth
      .size("size") // key name to size bubbles
      .color("date").order({ "sort": "asc", "value": "date" }) // color by each group
      .draw(); // finally, draw the visualization!
    }
  },
  computed: {
    myStyles: function myStyles() {
      return {
        height: this.height + 'px',
        position: 'relative'
      };
    }
  },
  mounted: function mounted() {
    console.log("MOUNTED LIVESTATS");
    this.loadUserList();

    var _this = this;
    this.$http.get('/stats/jobcounts', {
      headers: {
        'Authorization': localStorage.getItem('jwtToken')
      }
    }).then(function (response) {
      var sample_data = response.data;

      _this.buildBubbleJobChart(sample_data);

      //
      // mounted () {
      //   setInterval(() => {
      //     this.fillData()
      //   }, 1000)
      // },
    }).catch(function (e) {
      _this.$root.$emit('snackbar', 'Error retrieving job count bubbles!');
    });
  }
});

/***/ }),

/***/ 289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
//
//
//
//
//
//


//import VueApexCharts from '../../../dist/vue-apexcharts'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LineExample',
  components: {
    apexcharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
  },
  props: ['seriesp', 'labelsp'],
  data: function data() {
    return {

      chartOptions: {},
      labels: ["1"],
      series: [{
        name: 'blank',
        data: [0]
      }]
    };
  },
  methods: {
    generateDayWiseTimeSeries: function generateDayWiseTimeSeries(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = baseval;
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
        series.push([x, y]);
        baseval += 86400000;
        i++;
      }
      return series;
    },
    updateChart: function updateChart() {
      console.log(this.series);
    }
  },
  watch: {
    seriesp: function seriesp(val) {
      console.log("SERIES CHANGED " + val);

      this.chartOptions = {
        // xaxis: {
        //   type: 'categories',
        //   categories: val.labels,
        //   axisBorder: {
        //     show: false
        //   },
        //   axisTicks: {
        //     show: false
        //   },
        //   labels: {
        //     show: false
        //   }
        //
        // },
        dataLabels: {
          enabled: false
        },
        stroke: {
          width: [1, 2, 1],
          curve: 'straight'
        },
        chart: {
          type: 'line',
          zoom: {
            enabled: true
          },
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: true,
              zoom: true,
              zoomin: true,
              zoomout: true,
              pan: true,
              reset: true
            },
            autoSelected: 'zoom'
          }
        }
      };
      console.log(this.chartOptions);
      this.series = val.series;
    },
    labelsp: function labelsp(val) {
      console.log("LABELS CHANGED " + val);
      this.labels = val;
      this.chartOptions.xaxis.categories = this.labels;
      var copy = this.chartOptions;
      this.chartOptions = [];
      this.chartOptions = copy;
    }
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stores_store__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__backend_vue_axios__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_ability__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__casl_vue__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__casl_ability_extra__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_chat_scroll__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_chat_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_chat_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_apexcharts__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_apexcharts__);
/* global NProgress */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.css'
// import 'vue-material/dist/theme/default-dark.css' // This line here
 // Ensure you are using css-loader

// ... other imports ...



// Vue.use(VueMaterial)





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = true;


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_chat_scroll___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuetify___default.a, {
  theme: {
    primary: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors___default.a.blueGrey.darken2,
    secondary: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors___default.a.blueGrey.lighten1,
    accent: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors___default.a.purple.base,
    error: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors___default.a.red.accent4,
    warning: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors___default.a.yellow.base,
    info: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors___default.a.blue.base,
    success: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_util_colors___default.a.green.base
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(598));



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_apexcharts___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__casl_vue__["a" /* abilitiesPlugin */], __WEBPACK_IMPORTED_MODULE_6__config_ability__["a" /* default */]);
// TODO: the next line is added for debugging purposes and should be removed for production build
window.ability = __WEBPACK_IMPORTED_MODULE_6__config_ability__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeResolve(function (to, from, next) {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (to, from) {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

// // before a request is made start the nprogress
// axios.interceptors.request.use(config => {
//   NProgress.start()
//   return config
// })
//
// // before a response is returned stop nprogress
// axios.interceptors.response.use(response => {
//   NProgress.done()
//   return response
// })

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    processRules: function processRules(ruleset) {
      var rules = [];

      ruleset.forEach(function (entry) {
        console.log(entry);
        rules.push(entry.casl_ability);
      });

      this.$store.dispatch('LOGIN');
      this.$ability.update(Object(__WEBPACK_IMPORTED_MODULE_10__casl_ability_extra__["a" /* unpackRules */])(rules));
    }
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  axios: __WEBPACK_IMPORTED_MODULE_5__backend_vue_axios__["default"],
  store: __WEBPACK_IMPORTED_MODULE_4__stores_store__["a" /* default */],
  ability: __WEBPACK_IMPORTED_MODULE_6__config_ability__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b2b3d90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(402);
function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3b2b3d90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b2b3d90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 299:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 306:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 341:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 347:
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/home/bradm/node_apps/WebPanel"]],"_development":true,"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/home/bradm/node_apps/WebPanel","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 401:
/***/ (function(module, exports) {

module.exports = {"name":"vsspanel","version":"1.0.4","description":"VSS Web Panel","author":"Adrian Gose, Nick Netterville","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","lint":"eslint --ext .js,.vue src"},"dependencies":{"@casl/ability":"^2.3.0","@casl/vue":"^0.4.1","@fortawesome/fontawesome":"^1.1.8","@fortawesome/vue-fontawesome":"0.0.22","apexcharts":"^3.10.1","axios":"^0.18.1","babel-preset-es2015":"^6.24.1","body-parser":"^1.18.3","chart.js":"^2.7.2","chartjs-plugin-zoom":"^0.6.5","fontawesome":"^4.7.2","generate-password":"^1.4.2","gfycat-style-urls":"^1.0.3","jsonwebtoken":"^8.3.0","minecraft-pinger":"^1.0.3","pdfmake":"^0.1.62","socket.io-client":"^2.1.1","vue":"^2.5.2","vue-apexcharts":"^1.5.1","vue-axios":"^2.1.1","vue-chartjs":"^3.4.0","vue-chat-scroll":"^1.3.3","vue-instant-pdf-viewer":"^1.0.2","vue-material":"^1.0.0-beta-10.2","vue-moment":"^4.0.0-0","vue-native-websocket":"^2.0.8","vue-router":"^3.0.1","vuetify":"^1.3.2","vuex":"^3.0.1","ws":"^5.2.2"},"devDependencies":{"autoprefixer":"^7.1.5","babel-core":"^6.26.0","babel-eslint":"^8.2.5","babel-loader":"^7.1.2","babel-plugin-transform-runtime":"^6.23.0","babel-preset-env":"^1.6.0","babel-preset-stage-2":"^6.24.1","babel-register":"^6.26.0","chalk":"^2.1.0","connect-history-api-fallback":"^1.4.0","copy-webpack-plugin":"^4.1.1","css-loader":"^0.28.7","cssnano":"^3.10.0","eslint":"^4.9.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.9.0","eslint-plugin-html":"^4.0.5","eslint-plugin-import":"^2.7.0","eslint-plugin-node":"^5.2.0","eslint-plugin-promise":"^3.6.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.16.3","extract-text-webpack-plugin":"^3.0.0","file-loader":"^1.1.5","friendly-errors-webpack-plugin":"^1.6.1","html-webpack-plugin":"^2.30.1","http-proxy-middleware":"^0.20.0","node-sass":"^4.13.0","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^3.2.0","ora":"^1.3.0","rimraf":"^2.6.2","sass-loader":"^7.0.3","semver":"^5.4.1","shelljs":"^0.7.8","sw-precache-webpack-plugin":"^0.11.4","uglify-es":"^3.1.3","url-loader":"^0.6.2","vue-loader":"^13.3.0","vue-style-loader":"^3.0.3","vue-template-compiler":"^2.5.2","webpack":"^3.7.1","webpack-bundle-analyzer":"^2.9.0","webpack-dev-middleware":"^1.12.0","webpack-hot-middleware":"^2.19.1","webpack-merge":"^4.1.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ 402:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":_vm.darktheme}},[_c('v-navigation-drawer',{attrs:{"disable-resize-watcher":true,"temporary":"","fixed":"","app":""},model:{value:(_vm.menuVisible),callback:function ($$v) {_vm.menuVisible=$$v},expression:"menuVisible"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.apps()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("dashboard")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Apps")])],1)],1),_vm._v(" "),(_vm.$can('is', 'admin'))?_c('v-list-group',{attrs:{"prepend-icon":"account_circle"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Administration")])],1),_vm._v(" "),_vm._l((_vm.admins),function(admin,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.navipage(admin[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(admin[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(admin[1])}})],1)],1)})],2):_vm._e(),_vm._v(" "),(_vm.$can('view', 'reports') || _vm.$can('is', 'admin'))?_c('v-list-group',{attrs:{"prepend-icon":"view_list"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Reporting")])],1),_vm._v(" "),_vm._l((_vm.reports),function(report,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.navipage(report[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(report[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(report[1])}})],1)],1)})],2):_vm._e(),_vm._v(" "),((_vm.$can('view', 'payroll') || _vm.$can('is', 'admin')))?_c('v-list-group',{attrs:{"prepend-icon":"remove_red_eye"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Screeners")])],1),_vm._v(" "),_vm._l((_vm.screeners),function(screener,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.navipage(screener[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(screener[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(screener[1])}})],1)],1)})],2):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.logout()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Logout")])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","fixed":"","color":"primary","dark":""}},[(_vm.loggedin)?_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.toggleMenu()}}}):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{attrs:{"color":"white"}},[_vm._v("VSS")])],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3"},[(!_vm.darktheme)?_c('i',{staticClass:"far fa-moon",on:{"click":function($event){_vm.darktheme = true}}}):_c('i',{staticClass:"fas fa-moon",on:{"click":function($event){_vm.darktheme = false}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',[_vm._v("VSS Panel v"+_vm._s(_vm.version)+"© Maxis Systems Inc. "+_vm._s(new Date().getFullYear())+"  ")]),_vm._v(" "),(_vm.wsconnected)?_c('i',{staticClass:"fas fa-plug",staticStyle:{"color":"green"}}):_c('i',{staticClass:"fas fa-plug",staticStyle:{"color":"red"}})],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":_vm.color,"multi-line":_vm.mode === 'multi-line',"timeout":_vm.timeout,"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"dark":"","flat":""},on:{"click":function($event){_vm.snackbar = false}}},[_vm._v("\n      Close\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 403:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_MainPage__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_AppLogin__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_AppSignup__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_analyzer_Analyzer__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_analyzer_JobPage__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Review__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_admin_Admin__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_admin_Overview__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_admin_Dashboard__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_admin_ManageUsers__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_admin_Settings__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_admin_Downloads__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_admin_LiveStats__ = __webpack_require__(511);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'AppLogin',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_AppLogin__["a" /* default */]
  }, {
    path: '/signup',
    name: 'AppSignup',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_AppSignup__["a" /* default */]
  }, {
    path: '/main',
    name: 'MainPage',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_MainPage__["a" /* default */]
  }, {
    path: '/analyzer', // Gotta keep the kennemer tradition
    name: 'Analyzer',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_analyzer_Analyzer__["a" /* default */],

    // Child routes
    children: [{
      path: 'jobpage',
      name: 'JobPage',
      component: __WEBPACK_IMPORTED_MODULE_6__pages_analyzer_JobPage__["a" /* default */]
    }]
  }, {
    path: '/review',
    name: 'Review',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_Review__["a" /* default */]
  }, {
    path: '/admin',
    name: 'Admin',

    // Parent routes still has a component
    component: __WEBPACK_IMPORTED_MODULE_8__pages_admin_Admin__["a" /* default */],

    // Child routes
    children: [{
      path: 'overview',
      name: 'Overview',
      component: __WEBPACK_IMPORTED_MODULE_9__pages_admin_Overview__["a" /* default */]
    }, {
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_10__pages_admin_Dashboard__["a" /* default */]
    }, {
      path: 'livestats',
      name: 'LiveStats',
      component: __WEBPACK_IMPORTED_MODULE_14__pages_admin_LiveStats__["a" /* default */]
    }, {
      path: 'manageusers',
      name: 'ManageUsers',
      component: __WEBPACK_IMPORTED_MODULE_11__pages_admin_ManageUsers__["a" /* default */]
    }, {
      path: 'settings',
      name: 'Settings',
      component: __WEBPACK_IMPORTED_MODULE_12__pages_admin_Settings__["a" /* default */]
    }, {
      path: 'downloads',
      name: 'Downloads',
      component: __WEBPACK_IMPORTED_MODULE_13__pages_admin_Downloads__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ 405:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPage_vue__ = __webpack_require__(130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9d73e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e9d73e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9d73e8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 406:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 407:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[(_vm.noAccess)?_c('v-jumbotron',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('h3',{staticClass:"display-3"},[_vm._v("Welcome to VSS!")]),_vm._v(" "),_c('span',{staticClass:"subheading"},[_vm._v("Unfortunately, you currently do not have access to any of the VSS services. Please consult with your administrator.")]),_vm._v(" "),_c('v-divider',{staticClass:"my-3"})],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[((_vm.$can('view', 'pdfs') || _vm.$can('is', 'admin')))?_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"color":"primary"}},[_c('v-card-title',{staticClass:"white--text",attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("PDF Review")]),_vm._v(" "),_c('div',[_vm._v("Review result PDF's")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.navipage('Review')}}},[_vm._v("Open")])],1)],1)],1):_vm._e(),_vm._v(" "),((_vm.$can('view', 'analyzer') || _vm.$can('is', 'admin')))?_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"color":"primary"}},[_c('v-card-title',{staticClass:"white--text",attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Job Manager")]),_vm._v(" "),_c('div',[_vm._v("Manage job states, information, and more.")])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.navipage('JobPage')}}},[_vm._v("Open")])],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 408:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogin_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0217df1d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogin_vue__ = __webpack_require__(410);
function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0217df1d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 409:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('v-toolbar',{attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Login to VSS")])],1),_vm._v(" "),_c('v-card-text',[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"login","label":"Login","type":"text"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"id":"password","prepend-icon":"lock","name":"password","label":"Password","type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","type":"submit"}},[_vm._v("Login")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 411:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSignup_vue__ = __webpack_require__(132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_051160de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSignup_vue__ = __webpack_require__(413);
function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSignup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_051160de_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSignup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 412:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 413:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-wrapper"},[_c('form',{staticClass:"md-layout",attrs:{"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}}},[_c('md-card',{staticClass:"md-layout-item"},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("Signup to KeiPanel")])]),_vm._v(" "),_c('md-card-content',[_c('div',{staticClass:"md-layout-item md-small-size-100"},[_c('md-field',[_c('label',[_vm._v("Username")]),_vm._v(" "),_c('md-input',{attrs:{"type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"md-layout-item md-small-size-100"},[_c('md-field',[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-primary",attrs:{"type":"submit"}},[_vm._v("Login")])],1)],1),_vm._v(" "),_c('md-snackbar',{attrs:{"md-duration":_vm.duration,"md-active":_vm.showSnackbar,"md-persistent":""},on:{"update:mdActive":function($event){_vm.showSnackbar=$event}}},[_c('span',[_vm._v(_vm._s(_vm.snackMessage))]),_vm._v(" "),_c('md-button',{staticClass:"md-primary",on:{"click":function($event){_vm.showSnackbar = false}}},[_vm._v("Ok")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 414:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b05b94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Analyzer_vue__ = __webpack_require__(415);
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b05b94_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Analyzer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 415:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPage_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb65c96a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPage_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bb65c96a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb65c96a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 417:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighRiskConfirmDialog_vue__ = __webpack_require__(144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7698295b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HighRiskConfirmDialog_vue__ = __webpack_require__(446);
function injectStyle (ssrContext) {
  __webpack_require__(444)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7698295b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighRiskConfirmDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7698295b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HighRiskConfirmDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 444:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{ref:"form"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Confirm Action!")])])]),_vm._v(" "),_c('v-card-text',[_c('h4',[_vm._v(_vm._s(_vm.confirmMessage))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"font-size":"18px"}},[_vm._v("To confirm, retype "),_c('div',{staticClass:"noselect",staticStyle:{"color":"#ff0f00"}},[_vm._v(_vm._s(_vm.confirmString))]),_vm._v(" exactly as shown below.")]),_vm._v(" "),_c('v-text-field',{ref:"typedString",attrs:{"rules":[function (v) { return v === _vm.confirmString || 'Confirm text does not match!'; }],"error-messages":_vm.errorMessages,"label":"Confirm Text","placeholder":"","required":""},model:{value:(_vm.typedString),callback:function ($$v) {_vm.typedString=$$v},expression:"typedString"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel Action")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.matches,"color":"error"},nativeOn:{"click":function($event){return _vm.confirmAction($event)}}},[_vm._v("Confirm Action")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","fill-height":"","fill-width":""}},[_c('v-card',[_c('v-card-title',[_vm._v("\n      Choose a Job\n      "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Show Done"},nativeOn:{"click":function($event){return _vm.loadJobList($event)}},model:{value:(_vm.includeFinalized),callback:function ($$v) {_vm.includeFinalized=$$v},expression:"includeFinalized"}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","color":"indigo","dark":""},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("date_range")])],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Job Date Range")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.menu1),callback:function ($$v) {_vm.menu1=$$v},expression:"menu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Begin Date","hint":"MM/DD/YYYY format","persistent-hint":"","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.beginDateFormat),callback:function ($$v) {_vm.beginDateFormat=$$v},expression:"beginDateFormat"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.menu1 = false}},model:{value:(_vm.date1),callback:function ($$v) {_vm.date1=$$v},expression:"date1"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"End Date","hint":"MM/DD/YYYY format","persistent-hint":"","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.endDateFormat),callback:function ($$v) {_vm.endDateFormat=$$v},expression:"endDateFormat"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date2),callback:function ($$v) {_vm.date2=$$v},expression:"date2"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.resetDateRange($event)}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.loadJobList($event)}}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"indigo","dark":"","width":"50"},nativeOn:{"click":function($event){return _vm.loadJobList($event)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("refresh")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.jobs,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.jobName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.jobDate))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.jobStatus))]),_vm._v(" "),_c('td',[((_vm.$can('resort', 'job') || _vm.$can('is', 'admin')))?_c('v-btn',{attrs:{"small":"","color":"primary"},nativeOn:{"click":function($event){_vm.openHighRiskDialog(props.item.rawId, 'resortjob', 'Are you SURE you want to re-sort this jobs photos? This will delete any existing photos and set the job back to the ListIn state')}}},[_vm._v("Resort Photos")]):_vm._e(),_vm._v(" "),((_vm.$can('delete', 'job') || _vm.$can('is', 'admin')))?_c('v-btn',{attrs:{"small":"","color":"error"},nativeOn:{"click":function($event){_vm.openHighRiskDialog(props.item.rawId, 'deletejob', 'Are you SURE you want to completely delete this job? This will remove everything about this job. (photos, subjects, analysis, list files, etc.)')}}},[_vm._v("Delete Job")]):_vm._e()],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Your search for \""+_vm._s(_vm.search)+"\" found no results.\n      ")])],1)],1),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"},{name:"show",rawName:"v-show",value:(_vm.fab),expression:"fab"}],attrs:{"dark":"","fab":"","fixed":"","bottom":"","right":"","color":"indigo"},on:{"click":_vm.toTop}},[_c('v-icon',[_vm._v("keyboard_arrow_up")])],1)],1),_vm._v(" "),_c('HighRiskConfirmDialog',{attrs:{"visible":_vm.confirmDialog,"confirm-string":_vm.jobIdToModify,"confirm-message":_vm.highRiskConfirmMessage,"action-type":_vm.highRiskActionType},on:{"close":function($event){_vm.confirmDialog=false},"confirmed":_vm.performHighRiskAction}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Review_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6712d022_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Review_vue__ = __webpack_require__(455);
function injectStyle (ssrContext) {
  __webpack_require__(449)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6712d022"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Review_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6712d022_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Review_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 449:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuePDFViewer_vue__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuePDFViewer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuePDFViewer_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e32f09d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuePDFViewer_vue__ = __webpack_require__(454);
function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VuePDFViewer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e32f09d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VuePDFViewer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 452:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styleObject)})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","fill-height":"","fill-width":""}},[_c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.dialogloading),callback:function ($$v) {_vm.dialogloading=$$v},expression:"dialogloading"}},[_c('v-card',{attrs:{"color":"primary"}},[_c('v-card-text',{staticClass:"white--text"},[_vm._v("\n        Downloading PDF...\n        "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"color":"white"},model:{value:(_vm.valueDeterminate),callback:function ($$v) {_vm.valueDeterminate=$$v},expression:"valueDeterminate"}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"color":"primary"}},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.openedfilename))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{staticClass:"white--text",attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Close")])],1)],1),_vm._v(" "),_c('vue-pdf-viewer',{staticStyle:{"height":"90vh"},attrs:{"url":_vm.pdfurl}})],1)],1),_vm._v(" "),_c('v-card',[_c('v-toolbar',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("View PDFS")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.filename))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.ctime,"MM-DD-YY")))]),_vm._v(" "),_c('td',[_c('v-btn',{on:{"click":function($event){_vm.openPDF(props.item.filename)}}},[_vm._v("Open")])],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Your search for \""+_vm._s(_vm.search)+"\" found no results.\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abc9d218_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__ = __webpack_require__(457);
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_abc9d218_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1328d170_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__ = __webpack_require__(460);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1328d170_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 459:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.tabindex = 0}}},[_vm._v("Event Log")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.tabindex = 1}}},[_vm._v("Current Sessions")])],1),_vm._v(" "),(_vm.tabindex == 0)?[_c('v-timeline',{staticClass:"scrollable",attrs:{"dense":""}},[_c('v-slide-x-reverse-transition',{attrs:{"group":"","hide-on-leave":""}},_vm._l((_vm.logs),function(message,index){return _c('v-timeline-item',{key:message.d,attrs:{"small":"","fill-dot":"","color":"primary"}},[_c('v-alert',{attrs:{"value":true,"color":_vm.boxColor(message.el)}},[_c('span',[_vm._v(_vm._s(message.un)+" | "+_vm._s(message.ip)+" | "+_vm._s(_vm._f("moment")(message.d,"MMMM Do YYYY, h:mma")))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(message.a)+" | "+_vm._s(message.c)+" | "+_vm._s(message.sc))]),_c('br'),_vm._v(" "),_c('div',[_vm._v(" "+_vm._s(message.m)+" | "+_vm._s(message.x)+".")])])],1)}))],1)]:_vm._e(),_vm._v(" "),(_vm.tabindex == 1)?[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.sessions,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.uid.local.email))]),_vm._v(" "),_c('td',[_vm._l((props.item.apps),function(item,index){return [(index.startsWith('analyzer'))?_c('v-chip',{attrs:{"color":"blue lighten-2"}},[[_c('strong',[_vm._v(_vm._s(index))]),_vm._v(" \n            ")],_vm._v(" "),(!_vm.smallscreen)?[_c('span',[_vm._v(_vm._s(item.current_activity))]),_vm._v(" \n            "),_c('span',[_vm._v(_vm._s(item.open_job_id))]),_vm._v(" \n            ")]:_vm._e()],2):(index.startsWith('entrysuite'))?_c('v-chip',{attrs:{"color":"blue darken-1"}},[[_c('strong',[_vm._v(_vm._s(index))]),_vm._v(" \n            ")],_vm._v(" "),(!_vm.smallscreen)?[_c('span',[_vm._v(_vm._s(item.current_activity))]),_vm._v(" \n            "),_c('span',[_vm._v(_vm._s(item.open_job_id))]),_vm._v(" \n            ")]:_vm._e()],2):(index === 'VSS WebPanel')?_c('v-chip',{attrs:{"color":"blue darken-3"}},[[_c('strong',[_vm._v(_vm._s(index))]),_vm._v(" \n            ")],_vm._v(" "),(!_vm.smallscreen)?[_c('span',[_vm._v(_vm._s(item.current_activity))]),_vm._v(" \n            "),_c('span',[_vm._v(_vm._s(item.open_job_id))]),_vm._v(" \n            ")]:_vm._e()],2):_vm._e()]})],2)]}}])})]:_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd1ecd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(491);
function injectStyle (ssrContext) {
  __webpack_require__(462)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bd1ecd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd1ecd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 462:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 153,
	"./af.js": 153,
	"./ar": 154,
	"./ar-dz": 155,
	"./ar-dz.js": 155,
	"./ar-kw": 156,
	"./ar-kw.js": 156,
	"./ar-ly": 157,
	"./ar-ly.js": 157,
	"./ar-ma": 158,
	"./ar-ma.js": 158,
	"./ar-sa": 159,
	"./ar-sa.js": 159,
	"./ar-tn": 160,
	"./ar-tn.js": 160,
	"./ar.js": 154,
	"./az": 161,
	"./az.js": 161,
	"./be": 162,
	"./be.js": 162,
	"./bg": 163,
	"./bg.js": 163,
	"./bm": 164,
	"./bm.js": 164,
	"./bn": 165,
	"./bn.js": 165,
	"./bo": 166,
	"./bo.js": 166,
	"./br": 167,
	"./br.js": 167,
	"./bs": 168,
	"./bs.js": 168,
	"./ca": 169,
	"./ca.js": 169,
	"./cs": 170,
	"./cs.js": 170,
	"./cv": 171,
	"./cv.js": 171,
	"./cy": 172,
	"./cy.js": 172,
	"./da": 173,
	"./da.js": 173,
	"./de": 174,
	"./de-at": 175,
	"./de-at.js": 175,
	"./de-ch": 176,
	"./de-ch.js": 176,
	"./de.js": 174,
	"./dv": 177,
	"./dv.js": 177,
	"./el": 178,
	"./el.js": 178,
	"./en-au": 179,
	"./en-au.js": 179,
	"./en-ca": 180,
	"./en-ca.js": 180,
	"./en-gb": 181,
	"./en-gb.js": 181,
	"./en-ie": 182,
	"./en-ie.js": 182,
	"./en-il": 183,
	"./en-il.js": 183,
	"./en-nz": 184,
	"./en-nz.js": 184,
	"./eo": 185,
	"./eo.js": 185,
	"./es": 186,
	"./es-do": 187,
	"./es-do.js": 187,
	"./es-us": 188,
	"./es-us.js": 188,
	"./es.js": 186,
	"./et": 189,
	"./et.js": 189,
	"./eu": 190,
	"./eu.js": 190,
	"./fa": 191,
	"./fa.js": 191,
	"./fi": 192,
	"./fi.js": 192,
	"./fo": 193,
	"./fo.js": 193,
	"./fr": 194,
	"./fr-ca": 195,
	"./fr-ca.js": 195,
	"./fr-ch": 196,
	"./fr-ch.js": 196,
	"./fr.js": 194,
	"./fy": 197,
	"./fy.js": 197,
	"./gd": 198,
	"./gd.js": 198,
	"./gl": 199,
	"./gl.js": 199,
	"./gom-latn": 200,
	"./gom-latn.js": 200,
	"./gu": 201,
	"./gu.js": 201,
	"./he": 202,
	"./he.js": 202,
	"./hi": 203,
	"./hi.js": 203,
	"./hr": 204,
	"./hr.js": 204,
	"./hu": 205,
	"./hu.js": 205,
	"./hy-am": 206,
	"./hy-am.js": 206,
	"./id": 207,
	"./id.js": 207,
	"./is": 208,
	"./is.js": 208,
	"./it": 209,
	"./it.js": 209,
	"./ja": 210,
	"./ja.js": 210,
	"./jv": 211,
	"./jv.js": 211,
	"./ka": 212,
	"./ka.js": 212,
	"./kk": 213,
	"./kk.js": 213,
	"./km": 214,
	"./km.js": 214,
	"./kn": 215,
	"./kn.js": 215,
	"./ko": 216,
	"./ko.js": 216,
	"./ky": 217,
	"./ky.js": 217,
	"./lb": 218,
	"./lb.js": 218,
	"./lo": 219,
	"./lo.js": 219,
	"./lt": 220,
	"./lt.js": 220,
	"./lv": 221,
	"./lv.js": 221,
	"./me": 222,
	"./me.js": 222,
	"./mi": 223,
	"./mi.js": 223,
	"./mk": 224,
	"./mk.js": 224,
	"./ml": 225,
	"./ml.js": 225,
	"./mn": 226,
	"./mn.js": 226,
	"./mr": 227,
	"./mr.js": 227,
	"./ms": 228,
	"./ms-my": 229,
	"./ms-my.js": 229,
	"./ms.js": 228,
	"./mt": 230,
	"./mt.js": 230,
	"./my": 231,
	"./my.js": 231,
	"./nb": 232,
	"./nb.js": 232,
	"./ne": 233,
	"./ne.js": 233,
	"./nl": 234,
	"./nl-be": 235,
	"./nl-be.js": 235,
	"./nl.js": 234,
	"./nn": 236,
	"./nn.js": 236,
	"./pa-in": 237,
	"./pa-in.js": 237,
	"./pl": 238,
	"./pl.js": 238,
	"./pt": 239,
	"./pt-br": 240,
	"./pt-br.js": 240,
	"./pt.js": 239,
	"./ro": 241,
	"./ro.js": 241,
	"./ru": 242,
	"./ru.js": 242,
	"./sd": 243,
	"./sd.js": 243,
	"./se": 244,
	"./se.js": 244,
	"./si": 245,
	"./si.js": 245,
	"./sk": 246,
	"./sk.js": 246,
	"./sl": 247,
	"./sl.js": 247,
	"./sq": 248,
	"./sq.js": 248,
	"./sr": 249,
	"./sr-cyrl": 250,
	"./sr-cyrl.js": 250,
	"./sr.js": 249,
	"./ss": 251,
	"./ss.js": 251,
	"./sv": 252,
	"./sv.js": 252,
	"./sw": 253,
	"./sw.js": 253,
	"./ta": 254,
	"./ta.js": 254,
	"./te": 255,
	"./te.js": 255,
	"./tet": 256,
	"./tet.js": 256,
	"./tg": 257,
	"./tg.js": 257,
	"./th": 258,
	"./th.js": 258,
	"./tl-ph": 259,
	"./tl-ph.js": 259,
	"./tlh": 260,
	"./tlh.js": 260,
	"./tr": 261,
	"./tr.js": 261,
	"./tzl": 262,
	"./tzl.js": 262,
	"./tzm": 263,
	"./tzm-latn": 264,
	"./tzm-latn.js": 264,
	"./tzm.js": 263,
	"./ug-cn": 265,
	"./ug-cn.js": 265,
	"./uk": 266,
	"./uk.js": 266,
	"./ur": 267,
	"./ur.js": 267,
	"./uz": 268,
	"./uz-latn": 269,
	"./uz-latn.js": 269,
	"./uz.js": 268,
	"./vi": 270,
	"./vi.js": 270,
	"./x-pseudo": 271,
	"./x-pseudo.js": 271,
	"./yo": 272,
	"./yo.js": 272,
	"./zh-cn": 273,
	"./zh-cn.js": 273,
	"./zh-hk": 274,
	"./zh-hk.js": 274,
	"./zh-tw": 275,
	"./zh-tw.js": 275
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;

/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BacklogGraph_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81abb1ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BacklogGraph_vue__ = __webpack_require__(490);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81abb1ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BacklogGraph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81abb1ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BacklogGraph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 485:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 490:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"#E0E0E0"}},[_c('apexcharts',{ref:"chart",attrs:{"type":"line","height":"600","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 491:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","fill-height":"","fill-width":""}},[_c('v-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('v-tab',{attrs:{"ripple":""}},[_vm._v("Data table")]),_vm._v(" "),_c('v-tab-item',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('h1',[_vm._v("Analyzed Data")]),_vm._v(" "),_c('v-chip',{staticClass:"white--text font-weight-bold",attrs:{"color":"blue","label":""}},[_vm._v(_vm._s(((_vm.startDate.replace(/-/g, '/')) + " -\n              " + (_vm.endDate.replace(/-/g, '/'))))+"\n            ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","lg2":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":"","outline":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary"},slot:"activator"},[_vm._v("Settings")]),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Lookup Settings")])]),_vm._v(" "),_c('v-card-text',[_c('v-form',{model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.statuses,"label":"Status","outline":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":['Get only this status', 'Get all statuses after'],"label":"Status rules","outline":""},model:{value:(_vm.statusRule),callback:function ($$v) {_vm.statusRule=$$v},expression:"statusRule"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.menu.startdate),callback:function ($$v) {_vm.$set(_vm.menu, "startdate", $$v)},expression:"menu.startdate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","rules":_vm.rules.startDate,"readonly":"","outline":""},slot:"activator",model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.menu.startdate = false}},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},model:{value:(_vm.menu.enddate),callback:function ($$v) {_vm.$set(_vm.menu, "enddate", $$v)},expression:"menu.enddate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"End Date","rules":_vm.rules.endDate,"readonly":"","outline":""},slot:"activator",model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},on:{"input":function($event){_vm.menu.enddate = false}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.formValid,"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.updateSearch($event)}}},[_vm._v("Close")])],1)],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers1,"items":_vm.analyzedData,"hide-actions":"","search":_vm.search,"loading":_vm.loading,"expand":_vm.expand,"item-key":"job_id"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:{'border_bottom': props.item.screener_name.includes('TOTAL')},on:{"click":function($event){_vm.expandRow(props)}}},[_c('td',[_vm._v(_vm._s(props.item.screener_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((props.item.job_id.length > 5) ? props.item.job_id.slice(5) : ((props.item.job_id) + " jobs"))+"\n                  ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.status_displayname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.camid))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.isdigital))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.screened))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.xcount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.screened - props.item.xcount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((100*(props.item.xcount / props.item.screened)).toFixed(1))+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.dilate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.lookoff))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.force_eye))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.focus))])])]}},{key:"expand",fn:function(props){return [_c('v-card',{attrs:{"flat":""}},[(_vm.selectedJobInfo)?_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Job Date","value":_vm.formatDate(_vm.selectedJobInfo.date),"readonly":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Finalized Date","value":_vm.formatDate(_vm.selectedJobInfo.finalized_date),"readonly":""}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"School","value":JSON.parse(_vm.selectedJobInfo.meta).addr2,"readonly":""}})],1)],1):_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"blue"}})],1)],1)]}}])})],1)],1)],1)],1),_vm._v(" "),_c('v-tab',{attrs:{"ripple":""}},[_vm._v("Graph")]),_vm._v(" "),_c('v-tab-item',[_c('v-flex',[_c('BacklogGraph',{ref:"graph",attrs:{"finalDate":_vm.finalDate}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.activeTab === 0)?_c('v-btn',{on:{"click":function($event){_vm.generateTablePDF()}}},[_vm._v("Export")]):_vm._e(),_vm._v(" "),(_vm.activeTab === 1)?_c('v-btn',{on:{"click":function($event){_vm.$refs.graph.generateGraphPDF()}}},[_vm._v("Export")]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageUsers_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_798e7fdb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageUsers_vue__ = __webpack_require__(505);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_798e7fdb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 493:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUserDialog_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f60428b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUserDialog_vue__ = __webpack_require__(498);
function injectStyle (ssrContext) {
  __webpack_require__(494)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f60428b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateUserDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f60428b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateUserDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","flat":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("add_circle_outline")])],1),_vm._v(" "),(_vm.userCreated)?_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("User Created!")])])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Realname","readonly":""},model:{value:(_vm.createdRealName),callback:function ($$v) {_vm.createdRealName=$$v},expression:"createdRealName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Username","readonly":""},model:{value:(_vm.createdUserName),callback:function ($$v) {_vm.createdUserName=$$v},expression:"createdUserName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","readonly":""},model:{value:(_vm.createdPassword),callback:function ($$v) {_vm.createdPassword=$$v},expression:"createdPassword"}}),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("Write down this information somewhere safe.")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Close")])],1)],1):_c('v-card',{ref:"form"},[_c('v-card-text',[_c('v-text-field',{ref:"realname",attrs:{"rules":[function () { return !!_vm.realname || 'This field is required'; }],"error-messages":_vm.errorMessages,"label":"Full Name","placeholder":"John Doe","required":""},model:{value:(_vm.realname),callback:function ($$v) {_vm.realname=$$v},expression:"realname"}}),_vm._v(" "),_c('v-text-field',{ref:"username",attrs:{"rules":[function () { return !!_vm.username || 'This field is required'; }],"error-messages":_vm.errorMessages,"label":"Username/E-Mail","placeholder":"john@doe.com","required":""},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('p',{staticClass:"text-xs-center"},[_vm._v("A password will be automatically generated for the user, in which they will be\n        forced to change upon initial login.")])],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-5"}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-slide-x-reverse-transition',[(_vm.formHasErrors)?_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"my-0",attrs:{"slot":"activator","icon":""},on:{"click":_vm.resetForm},slot:"activator"},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),_c('span',[_vm._v("Refresh form")])],1):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.createUser}},[_vm._v("Submit")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenerDialog_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404d3159_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenerDialog_vue__ = __webpack_require__(500);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScreenerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404d3159_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScreenerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 500:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","flat":"","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("add_circle_outline")])],1),_vm._v(" "),_c('v-card',{ref:"form"},[_c('v-card-text',[_c('v-text-field',{ref:"name",attrs:{"rules":[function () { return !!_vm.name || 'This field is required'; }],"error-messages":_vm.errorMessages,"label":"Full Name","placeholder":"John Doe","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{ref:"loc",attrs:{"rules":[
            function () { return !!_vm.loc || 'This field is required'; },
            function () { return !!_vm.loc && _vm.loc.length <= 2 || 'Location code must be 2 characters'; }],"label":"Location (2 Letter State Code)","placeholder":"AL","counter":"2","required":""},model:{value:(_vm.loc),callback:function ($$v) {_vm.loc=$$v},expression:"loc"}}),_vm._v(" "),_c('v-text-field',{ref:"crewid",attrs:{"rules":[function () { return !!_vm.crewid || 'This field is required'; }],"label":"Crew ID","placeholder":"1337","required":""},model:{value:(_vm.crewid),callback:function ($$v) {_vm.crewid=$$v},expression:"crewid"}})],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-5"}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-slide-x-reverse-transition',[(_vm.formHasErrors)?_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"my-0",attrs:{"slot":"activator","icon":""},on:{"click":_vm.resetForm},slot:"activator"},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),_c('span',[_vm._v("Refresh form")])],1):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.submit}},[_vm._v("Add")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageUserDialog_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10d5a9df_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageUserDialog_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(502)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10d5a9df"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageUserDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10d5a9df_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageUserDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 502:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('v-card',{ref:"form"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Manage User")])])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{ref:"realname",attrs:{"rules":[function () { return !!_vm.realname || 'This field is required'; }],"error-messages":_vm.errorMessages,"label":"Full Name","placeholder":"John Doe","required":""},model:{value:(_vm.realname),callback:function ($$v) {_vm.realname=$$v},expression:"realname"}}),_vm._v(" "),_c('v-list',{attrs:{"subheader":"","three-line":""}},[_c('v-subheader',[_vm._v("Permissions")]),_vm._v(" "),_vm._l((_vm.permissions),function(item,index){return [_c('v-list-tile',{on:{"click":function($event){}}},[_c('v-list-tile-action',[_c('v-switch',{model:{value:(item.hasPermission),callback:function ($$v) {_vm.$set(item, "hasPermission", $$v)},expression:"item.hasPermission"}})],1),_vm._v(" "),_c('v-list-tile-content',{on:{"click":function($event){_vm.notifications = !_vm.notifications}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.description))])],1)],1)]})],2)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-5"}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){$event.stopPropagation();_vm.show=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-slide-x-reverse-transition',[(_vm.formHasErrors)?_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"my-0",attrs:{"slot":"activator","icon":""},on:{"click":_vm.resetForm},slot:"activator"},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),_c('span',[_vm._v("Refresh form")])],1):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.updateUser}},[_vm._v("Update")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":"","fill-height":"","fill-width":""}},[_c('v-card',[_c('v-toolbar',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("Manage People")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.tab)?_c('v-btn',{attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){return _vm.loadUserList($event)}}},[_c('v-icon',[_vm._v("refresh")])],1):_c('v-btn',{attrs:{"flat":"","icon":""},nativeOn:{"click":function($event){return _vm.loadScreenerList($event)}}},[_c('v-icon',[_vm._v("refresh")])],1),_vm._v(" "),(!_vm.tab)?_c('CreateUserDialog',{on:{"updateUserList":_vm.loadUserList}}):_c('ScreenerDialog',{on:{"update":_vm.loadScreenerList}}),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","align-with-title":"","color":"primary"},slot:"extension",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider',{attrs:{"color":"secondary"}}),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-tab',{key:item},[_vm._v("\n          "+_vm._s(item)+"\n        ")])})],2)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.users,"search":_vm.search,"rows-per-page-items":[10,15,25]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.local.realname))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.local.email))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("moment")(props.item.local.lastlogin,"MMMM Do YYYY, h:mm a")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.local.roleLevel > 10 ? "Admin" : "User"))]),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"small":"","color":"secondary"},on:{"click":function($event){_vm.openManageUserDialog(props.item)}}},[_vm._v("Manage User")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"error"},on:{"click":function($event){_vm.deleteUser(props.item)}}},[_vm._v("Delete User")])],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n            Your search for \""+_vm._s(_vm.search)+"\" found no results.\n          ")])],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-data-table',{attrs:{"headers":_vm.headersScreeners,"items":_vm.screeners,"search":_vm.search,"rows-per-page-items":[10,15,25]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.crewid))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.name + " " + props.item.hnotes))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.loc))]),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"small":"","color":"secondary"}},[_vm._v("Screener Profile")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"error"},on:{"click":function($event){_vm.deleteScreener(props.item)}}},[_vm._v("Remove Screener")])],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n            Your search for \""+_vm._s(_vm.search)+"\" found no results.\n          ")])],1)],1)],1)],1),_vm._v(" "),_c('ManageUserDialog',{attrs:{"visible":_vm.manageUserDialogOpened,"user-data":_vm.manageUserData},on:{"close":function($event){_vm.manageUserDialogOpened=false},"updated":_vm.loadUserList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 506:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319aa773_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(507);
var normalizeComponent = __webpack_require__(6)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_319aa773_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 507:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-jumbotron',[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"align-center":""}},[_c('v-flex',[_c('h3',{staticClass:"display-3"},[_vm._v("Settings")]),_vm._v(" "),_c('v-divider',{staticClass:"my-3"})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 508:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Downloads_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d18228a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Downloads_vue__ = __webpack_require__(510);
function injectStyle (ssrContext) {
  __webpack_require__(509)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Downloads_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d18228a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Downloads_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 509:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"white--text",attrs:{"color":"blue-grey darken-2"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Download Analyzer")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","href":"http://vrc.api.maxis.io:8000/static/VSS-Analyzer-Master.exe"}},[_vm._v("Download")])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"white--text",attrs:{"color":"blue-grey darken-2"}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Download FrameSorter/DataEntry Suite")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","href":"http://vrc.api.maxis.io:8000/static/FrameSorter-Master.exe"}},[_vm._v("Download")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 511:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiveStats_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199af180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiveStats_vue__ = __webpack_require__(567);
function injectStyle (ssrContext) {
  __webpack_require__(512)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LiveStats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_199af180_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LiveStats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 512:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 513:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_reactivechart__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);






/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */],
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_reactivechart__["a" /* reactiveProp */]],
  data: function data() {
    return {
      offsetindex: 30,
      options: {
        responsive: true,
        legend: {
          labels: {
            fontColor: "white",
            fontSize: 11
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              fontColor: "white",
              fontSize: 11,
              stepSize: 1,
              beginAtZero: true
            }
          }],
          xAxes: [{
            ticks: {
              fontColor: "white",
              fontSize: 14,
              stepSize: 1,
              beginAtZero: true
            }
          }]
        },
        maintainAspectRatio: false,

        // Container for zoom options
        zoom: {
          // Boolean to enable zooming
          enabled: true,

          // Zooming directions. Remove the appropriate direction to disable
          // Eg. 'y' would only allow zooming in the y direction
          mode: 'x'
        },

        animation: {
          duration: 0
        }
      }
    };
  },
  methods: {
    subscribeToStore: function subscribeToStore() {
      var _this = this;

      console.log("SUBSCRIBING TO LOGS FOR " + this.username);
      this.$store.subscribe(function (mutation, state) {
        if (mutation.type === 'addLog') {
          var lastlog = state.logs[state.logs.length - 1];
          if (lastlog.un === _this.username) {
            _this.incrementLastTimePeriod();
          }
        }
      });
    },
    getDataFromApi: function getDataFromApi(cb) {
      var _this2 = this;

      console.log("Loading graph data for user " + this.username);

      this.$http.get('/stats/' + this.username + '/' + this.interval + '/today/2018-09-13', {
        headers: {
          'Authorization': localStorage.getItem('jwtToken')
        }
      }).then(function (response) {

        console.log("Loading graph data for user " + _this2.username);

        var responsedata = response.data;
        var dates = responsedata.dates;

        var counts = responsedata.counts;

        _this2.updateDatasetData(dates, counts);

        cb();
      }).catch(function (e) {
        // console.log(JSON.stringify(e));


        console.log("Loading graph data for user " + _this2.username);
        _this2.$root.$emit('snackbar', e.response.data.msg);
      });
    },
    updateDatasetData: function updateDatasetData(dates, counts) {

      var dataPoints = {
        labels: dates,
        datasets: [{
          label: this.username,
          backgroundColor: '#f87979',
          data: counts
        }]
      };
      this.chartData = dataPoints;

      console.log("Updated chart data for " + this.username);

      this.renderChart(this.chartData, this.options);
    },
    incrementLastTimePeriod: function incrementLastTimePeriod() {
      console.log("INCREMENTING " + this.username);

      var arr = {};

      var start = new Date();
      start.setHours(0, 0, 0, 0);
      var end = new Date();

      if (!this.startdate) {
        start = __WEBPACK_IMPORTED_MODULE_3_moment___default()(start);
        end = __WEBPACK_IMPORTED_MODULE_3_moment___default()(end);
      }

      var lastdate = start;
      var doloop = true;

      var index = 0;

      while (doloop) {
        lastdate = lastdate.add(this.interval, 'm');

        if (__WEBPACK_IMPORTED_MODULE_3_moment___default()(lastdate).diff(end, "minutes") > 0) {
          doloop = false;
        } else {
          index++;
        }
      }

      // console.log(index);

      index--;

      var dataPoints = this.chartData;

      var counts = dataPoints.datasets[0].data;

      counts[index] = counts[index] + 1;

      // console.log(counts)

      dataPoints.datasets[0].data = counts;

      this.chartData = dataPoints;

      this.renderChart(this.chartData, this.options);
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.addPlugin(__WEBPACK_IMPORTED_MODULE_2_chartjs_plugin_zoom___default.a);

    this.getDataFromApi(function () {
      _this3.subscribeToStore();
      //
      //  setInterval(() => {
      //      this.incrementLastTimePeriod();
      // }, 1000)
    });
  }
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reactiveData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return reactiveProp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


function dataHandler(newData, oldData) {
  if (oldData) {
    var chart = this.$data._chart;

    // Get new and old DataSet Labels
    var newDatasetLabels = newData.datasets.map(function (dataset) {
      return dataset.label;
    });

    var oldDatasetLabels = oldData.datasets.map(function (dataset) {
      return dataset.label;
    });

    // Stringify 'em for easier compare
    var oldLabels = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(oldDatasetLabels);
    var newLabels = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newDatasetLabels);

    // Check if Labels are equal and if dataset length is equal
    if (newLabels === oldLabels && oldData.datasets.length === newData.datasets.length) {
      newData.datasets.forEach(function (dataset, i) {
        // Get new and old dataset keys
        var oldDatasetKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(oldData.datasets[i]);
        var newDatasetKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(dataset);

        // Get keys that aren't present in the new data
        var deletionKeys = oldDatasetKeys.filter(function (key) {
          return key !== '_meta' && newDatasetKeys.indexOf(key) === -1;
        });

        // Remove outdated key-value pairs
        deletionKeys.forEach(function (deletionKey) {
          delete chart.data.datasets[i][deletionKey];
        });

        // Update attributes individually to avoid re-rendering the entire chart
        for (var attribute in dataset) {
          if (dataset.hasOwnProperty(attribute)) {
            chart.data.datasets[i][attribute] = dataset[attribute];
          }
        }
      });

      if (newData.hasOwnProperty('labels')) {
        chart.data.labels = newData.labels;
        this.$emit('labels:update');
      }
      if (newData.hasOwnProperty('xLabels')) {
        chart.data.xLabels = newData.xLabels;
        this.$emit('xlabels:update');
      }
      if (newData.hasOwnProperty('yLabels')) {
        chart.data.yLabels = newData.yLabels;
        this.$emit('ylabels:update');
      }
      chart.update();
      this.$emit('chart:update');
    } else {
      if (chart) {
        chart.destroy();
        this.$emit('chart:destroy');
      }
      this.renderChart(this.chartData, this.options);
      this.$emit('chart:render');
    }
  } else {
    if (this.$data._chart) {
      this.$data._chart.destroy();
      this.$emit('chart:destroy');
    }
    this.renderChart(this.chartData, this.options);
    this.$emit('chart:render');
  }
}

var reactiveData = {
  data: function data() {
    return {
      chartData: null,
      username: '',
      interval: 30,
      startdate: null,
      enddate: null
    };
  },


  watch: {
    'chartData': dataHandler
  }
};

var reactiveProp = {
  props: {
    chartData: {
      required: false
    },
    username: {
      required: true
    },
    interval: {
      required: true
    },
    startdate: {
      required: false
    },
    enddate: {
      required: false
    }
  },
  watch: {
    'chartData': dataHandler
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
  reactiveData: reactiveData,
  reactiveProp: reactiveProp
});

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserActivityApex_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9494cfc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserActivityApex_vue__ = __webpack_require__(566);
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserActivityApex_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9494cfc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserActivityApex_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example"},[_c('apexcharts',{attrs:{"type":"line","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{attrs:{"id":"viz"}}),_vm._v(" "),_c('v-flex',[_c('v-card',{attrs:{"dark":""}},[_vm._l((_vm.users),function(user){return [_c('individual-user-graph',{attrs:{"username":user.local.email,"interval":30}})]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jsonwebtoken__);




var socket;
var pingInterval;
var recondelay = 50;
var apiKey = 'MTMzN2JveGx1bmNoc2FsYWQ=';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  state: {
    loggedIn: false,
    darktheme: false,
    websocketConnected: false,
    logs: [],
    sessions: []
  },
  actions: {
    LOGIN: function LOGIN(_ref) {
      var commit = _ref.commit;

      commit('SET_LOGGED_IN', true);
    },
    LOGOUT: function LOGOUT(_ref2) {
      var commit = _ref2.commit;

      commit('SET_LOGGED_IN', false);
    },
    GET_LATEST_LOGS: function GET_LATEST_LOGS(_ref3) {
      var commit = _ref3.commit;
    }
  },
  mutations: {
    addLog: function addLog(state, text) {
      if (state.logs.length > 50) {
        state.logs.shift();
      }
      state.logs.push(text);
    },
    setSessions: function setSessions(state, data) {
      state.sessions = data;
    },
    clearLogs: function clearLogs(state) {
      state.logs = [];
    },

    SET_LOGGED_IN: function SET_LOGGED_IN(state, loggedin) {
      state.loggedIn = loggedin;
    },
    SET_SOCKET_CONNECTED: function SET_SOCKET_CONNECTED(state, connected) {
      state.websocketConnected = connected;
    }
  },
  getters: {
    lastlog: function lastlog(state) {
      return state.logs[state.logs.length - 1];
    },
    logs: function logs(state) {
      return state.logs;
    },
    loggedin: function loggedin(state) {
      return state.loggedIn;
    },
    wsconnected: function wsconnected(state) {
      return state.websocketConnected;
    },
    sessions: function sessions(state) {
      return state.sessions;
    }
  }
});

function connect() {
  socket = new WebSocket("wss://vrc.api.maxis.io/ws");

  socket.onmessage = function (msg) {
    var state = socket.readyState;

    if (state !== 1) {
      store.commit('SET_SOCKET_CONNECTED', false);
    } else {
      store.commit('SET_SOCKET_CONNECTED', true);
    }

    var msg = JSON.parse(msg.data);

    if (msg.err) {
      this.$root.$emit('snackbar', msg.m);
    }

    switch (msg.type) {
      case "getsessions":
        var d = msg.d;
        store.commit('setSessions', d);
        break;
      case "getlast":
        var d = msg.d;

        store.commit('clearLogs');
        d.forEach(function (entry) {
          store.commit('addLog', entry);
        });

        break;
      case "log":
        store.commit('addLog', msg.d);

        break;
      case "connected":
        socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ "type": "getlast" }));
        pingInterval = setInterval(function () {
          var token = localStorage.getItem('jwtToken');
          var decoded = __WEBPACK_IMPORTED_MODULE_3_jsonwebtoken___default.a.decode(token.split(" ")[1]);
          socket.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            "type": "session",
            "d": {
              "uid": decoded._id,
              "apps": ["VSS WebPanel"]
            }
          }));
        }, 1000);
        break;
    }
  };
  socket.onerror = function (err) {
    console.error('Socket encountered error: ', err.message, 'Closing socket');
    socket.close();
    recondelay = recondelay * 1.5;
    if (recondelay > 10000) {
      recondelay = 1000;
    }
  };

  socket.onclose = function (err) {
    if (pingInterval) {
      clearInterval(pingInterval);
    }
    console.log('Socket is closed. Reconnect will be attempted in ' + recondelay + ' ms.', err.reason);
    store.commit('SET_SOCKET_CONNECTED', false);
    setTimeout(function () {
      socket = undefined;
      connect();
    }, recondelay);
  };

  socket.onopen = function (err) {
    console.log("CONNECTED TO WebSocket");
    store.commit('SET_SOCKET_CONNECTED', true);
    recondelay = 50;
  };
}

connect();

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_axios__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__axios__ = __webpack_require__(573);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2__axios__["a" /* default */]);

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* global localStorage */



var API_URL = 'https://vrc.api.maxis.io/v1/';

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: API_URL,
  headers: {
    'apikey': 'MTMzN2JveGx1bmNoc2FsYWQ=',
    'Content-Type': 'application/json',
    'From-App': 'VSS WebPanel'
  }
}));

/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__casl_ability__ = __webpack_require__(295);


/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */
function subjectName(item) {
  if (!item || typeof item === 'string') {
    return item;
  }

  return item.__type;
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__casl_ability__["b" /* AbilityBuilder */].define({ subjectName: subjectName }, function (can) {
  can(['view', 'download'], 'PDFS');
  can(['update', 'delete'], 'Todo', { assignee: 'me' });
}));

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casl_ability_extra__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__package__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__package___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__package__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PersistentFull',
  data: function data() {
    return {
      darktheme: true,
      menuVisible: false,
      snackbar: false,
      color: ' ',
      mode: '',
      timeout: 4000,
      text: 'Hello, I\'m a snackbar',
      admins: [['Overview', 'remove_red_eye', 'Overview'], ['Live Stats', 'show_chart', 'LiveStats'], ['Manage People', 'people_outline', 'ManageUsers'], ['Settings', 'settings', 'Settings'], ['Downloads', 'arrow_downward', 'Downloads']],
      reports: [['Dashboard', 'reorder', 'Dashboard']],
      screeners: [['Payroll', 'attach_money', 'Overview']]
      // reports: [
      //   ['Production', 'insert_drive_file', 'Overview']
      // ]
    };
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    logout: function logout() {
      localStorage.removeItem('jwtToken');
      this.$router.push({
        name: 'AppLogin'
      });
      this.$store.dispatch('LOGOUT');
      this.menuVisible = false;
      this.$ability.update({});
    },
    apps: function apps() {
      this.$router.push({
        name: 'MainPage'
      });
    },
    admin: function admin() {
      this.$router.push({
        name: 'Admin'
      });
    },
    navipage: function navipage(page) {
      this.$router.push({
        name: page
      });
    }
  },
  computed: {
    loggedin: function loggedin() {
      return this.$store.getters.loggedin;
    },
    wsconnected: function wsconnected() {
      return this.$store.getters.wsconnected;
    },
    version: function version() {
      return __WEBPACK_IMPORTED_MODULE_2__package___default.a.version;
    }

  },
  beforeMount: function beforeMount() {
    if (localStorage.getItem('darktheme') !== null) {
      var isDark = localStorage.getItem('darktheme');

      this.darktheme = isDark === 'true';
      this.$store.state.darktheme = this.darktheme;
    } else {
      localStorage.setItem('darktheme', this.darktheme);
      this.$store.state.darktheme = this.darktheme;
    }

    if (localStorage.getItem('jwtToken')) {
      var token = localStorage.getItem('jwtToken');

      var decoded = __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken___default.a.decode(String(token).split(' ')[1]);

      this.processRules(decoded.rules);

      this.$router.push({
        name: 'MainPage'
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    console.log("CHECK IF SESSION EXPIRE HERE");

    if (localStorage.getItem('jwtToken')) {

      var token = localStorage.getItem('jwtToken');

      var decoded = __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken___default.a.decode(String(token).split(' ')[1]);

      console.log(decoded);

      var current_time = new Date().getTime() / 1000;

      var jwtexp = decoded.exp;

      if (current_time > jwtexp) {
        this.text = "Your session has expired. Please login again!";
        this.snackbar = true;
        this.color = 'red';

        this.logout();
      }
    } else {
      this.logout();
    }

    this.$root.$on('snackbar', function (message) {
      _this.text = message;
      _this.snackbar = true;
      _this.color = 'red';
    });
  },
  watch: {
    darktheme: function darktheme(after, before) {
      localStorage.setItem('darktheme', after);
      this.$store.state.darktheme = after;
    }
  }
});

/***/ })

},[296]);


// WEBPACK FOOTER //
// static/js/app.dd08d74dd2e66dc84922.js